import { createRouter, createWebHashHistory } from 'vue-router'
const defaultTitle = '成绩查询'
const webRoutes = [
  {
    path: '/web',
    redirect: '/web/login',
    children: [
      {
        path: 'login',
        component: () => import('../page/Web/login/index.vue'),
        meta: {
          title: '登录'
        }
      },

      {
        path: 'home/:id',
        component: () => import('../page/Web/home/index.vue'),

      },
      {
        path: 'viewResults',
        component: () => import('../page/Web/viewResults/index.vue'),
      },
    ],
  },
]
const routes = [
  ...webRoutes,
  {
    path: '/',
    redirect: '/login',
  },
  // 登录
  {
    path: '/login',
    name: 'HomeLogin',
    component: () => import('../page/Login/Login.vue')
  },
  // 查看成绩
  {
    path: '/viewResults',
    name: 'ViewResults',
    component: () => import('../page/ViewResults/ViewResults.vue')
  },
  // 首页
  {
    path: '/home/:id',
    name: 'Home',
    component: () => import('../page/Home/Home.vue')
  },
  // 选择科目
  {
    path: '/selectSubject/:id',
    name: 'SelectSubject',
    component: () => import('../page/SelectSubject/SelectSubject.vue')
  },
  // 答题明细
  {
    path: '/answerDetails/:id',
    name: 'AnswerDetails',
    component: () => import('../page/AnswerDetails/AnswerDetails.vue')
  },
  // 试卷解析
  {
    path: '/paperParse',
    name: 'PaperParse',
    component: () => import('../page/PaperParse/PaperParse.vue'),
    meta: {
      title: '查看试卷解析'
    }
  },
  // 订单详情
  {
    path: '/orderDetails',
    name: 'OrderDetails',
    component: () => import('../page/OrderDetails/OrderDetails.vue')
  },
  // 支付结果
  {
    path: '/paymentResult',
    name: 'PaymentResult',
    component: () => import('../page/PaymentResult/PaymentResult.vue')
  },
  // 单独PDF
  {
    path: '/downloadPDF',
    name: 'DownloadPDF',
    component: () => import('../page/DownloadPDF/DownloadPDF.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || defaultTitle
  next()
})
export default router
